export default __webpack_public_path__ + "static/media/absolute-1.6fac234d.png";